if (!customElements.get('armada-more-blog-posts')) {
  class ArmadaMoreBlogPosts extends HTMLElement {
    constructor() {
      super();
      this.state = { category: 'all' };
      // Each unique category tracks its own reveal limit so Load More on one
      // tab doesn't bleed into another, and switching tabs restores that tab's
      // reveal state.
      this.revealLimitsByKey = new Map();
    }

    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.empty = this.querySelector('[data-empty]');
      this.cards = Array.from(this.querySelectorAll('.armada-more-blog-posts-card'));
      this.tabs = Array.from(this.querySelectorAll('.armada-more-blog-posts__tab'));
      this.loadMoreBtn = this.querySelector('[data-load-more]');
      this.resultsInfo = this.querySelector('[data-results-info]');
      this.loadMoreStep = parseInt(this.dataset.loadMoreStep, 10) || 4;

      this.bindTabs();
      this.bindLoadMore();
      this.applyFilters();
    }

    activateTab(tab) {
      this.state.category = tab.dataset.category;
      this.tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('armada-more-blog-posts__tab--active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      if (this.grid && tab.id) {
        this.grid.setAttribute('aria-labelledby', tab.id);
      }
      this.applyFilters();
    }

    bindTabs() {
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');

        tab.addEventListener('click', () => {
          this.activateTab(tab);
        });

        tab.addEventListener('keydown', (event) => {
          const last = this.tabs.length - 1;
          let targetIndex = null;
          switch (event.key) {
            case 'ArrowRight':
              targetIndex = index === last ? 0 : index + 1;
              break;
            case 'ArrowLeft':
              targetIndex = index === 0 ? last : index - 1;
              break;
            case 'Home':
              targetIndex = 0;
              break;
            case 'End':
              targetIndex = last;
              break;
            default:
              return;
          }
          event.preventDefault();
          const nextTab = this.tabs[targetIndex];
          if (!nextTab) return;
          this.activateTab(nextTab);
          nextTab.focus();
        });
      });
    }

    getFilterKey() {
      return this.state.category;
    }

    getRevealLimit(key) {
      if (!this.revealLimitsByKey.has(key)) {
        this.revealLimitsByKey.set(key, this.loadMoreStep);
      }
      return this.revealLimitsByKey.get(key);
    }

    cardMatchesFilters(card) {
      const { category } = this.state;
      const cats = (card.dataset.category || '').split(/\s+/).filter(Boolean);
      return category === 'all' || cats.includes(category);
    }

    applyFilters() {
      const key = this.getFilterKey();
      const limit = this.getRevealLimit(key);

      let totalMatches = 0;
      let shown = 0;

      this.cards.forEach((card) => {
        const matches = this.cardMatchesFilters(card);
        if (!matches) {
          card.classList.add('armada-more-blog-posts-card--hidden');
          return;
        }

        totalMatches += 1;
        if (totalMatches <= limit) {
          card.classList.remove('armada-more-blog-posts-card--hidden');
          shown += 1;
        } else {
          card.classList.add('armada-more-blog-posts-card--hidden');
        }
      });

      if (this.empty) this.empty.hidden = totalMatches !== 0;

      this.updateResultsInfo(shown, totalMatches);
      this.updateLoadMoreVisibility(shown, totalMatches);
    }

    bindLoadMore() {
      if (!this.loadMoreBtn) return;
      this.loadMoreBtn.addEventListener('click', () => this.handleLoadMore());
    }

    handleLoadMore() {
      const key = this.getFilterKey();
      const next = this.getRevealLimit(key) + this.loadMoreStep;
      this.revealLimitsByKey.set(key, next);
      this.applyFilters();
    }

    updateResultsInfo(shown, total) {
      if (!this.resultsInfo) return;
      const template = this.resultsInfo.dataset.template || 'Showing [SHOWN] of [TOTAL] results';
      this.resultsInfo.textContent = template
        .replace('[SHOWN]', shown)
        .replace('[TOTAL]', total);
      this.resultsInfo.hidden = total === 0;
    }

    updateLoadMoreVisibility(shown, total) {
      if (!this.loadMoreBtn) return;
      this.loadMoreBtn.hidden = shown >= total;
    }
  }

  customElements.define('armada-more-blog-posts', ArmadaMoreBlogPosts);
}
